import React, { useState, useEffect, useCallback  } from "react"; // ← useCallback import edin
import { useSnackbar } from "notistack";
import {
  FaPlus,
  FaEdit,
  FaSave,
  FaBuilding,
  FaMapMarkedAlt,
  FaUserTie,
  FaUsers,
  FaEnvelope,
  FaPhone,
} from "react-icons/fa";
import {
  Box,
  CircularProgress,
  Typography,
  Paper,
  Button,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Modal,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Stack,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
} from "@mui/material";

import {
  getUreticiBilgileri,
  saveProducer,
  getIllerForRegister,
  getIlcelerForRegister,
  getUsers,
  addUser,
  updateUser,
  getUlkeKodlari,
  getTanimEgitimDurumu,
} from "../services/api";
import "./UreticiBilgileri.css"; // ← CSS import'u ekleyin

const UreticiBilgileri = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [ureticiData, setUreticiData] = useState({});
  const [kullaniciData, setKullaniciData] = useState([]);
  const [iller, setIller] = useState([]);
  const [ilceler, setIlceler] = useState([]);
  const [egitimDurumlari, setEgitimDurumlari] = useState([]);
  const [ulkeler, setUlkeler] = useState([]);
  const [sirketler, setSirketler] = useState([
    { ENTEGRE_SIRKET_ID: 1, SIRKET_ADI: "BEYPİLİÇ TAVUKÇULUK A.Ş." },
    { ENTEGRE_SIRKET_ID: 2, SIRKET_ADI: "ERPİLİÇ" },
    { ENTEGRE_SIRKET_ID: 3, SIRKET_ADI: "BOLCA HİNDİ" },
  ]);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [isUserModalOpen, setIsUserModalOpen] = useState(false);
  const [editingUser, setEditingUser] = useState(null);





  // fetchTanimVerileri fonksiyonu
  const fetchTanimVerileri = useCallback(async () => {
    try {
      const [illerRes, ulkelerRes, egitimRes] = await Promise.all([
        getIllerForRegister(),
        getUlkeKodlari(),
        getTanimEgitimDurumu(),
      ]);

      setIller(Array.isArray(illerRes.data?.data) ? illerRes.data.data : []);
      setUlkeler(
        Array.isArray(ulkelerRes.data?.data) ? ulkelerRes.data.data : []
      );
      setEgitimDurumlari(
        Array.isArray(egitimRes.data?.data) ? egitimRes.data.data : []
      );
    } catch (error) {
      // console.error("❌ Tanım verileri yüklenirken hata:", error);
      enqueueSnackbar("Tanım verileri yüklenemedi", { variant: "error" });
    }
  }, [enqueueSnackbar]);

  // fetchIlceler fonksiyonu
  const fetchIlceler = useCallback(async (ilId) => {
    try {
      if (!ilId) {
        setIlceler([]);
        return;
      }

      const response = await getIlcelerForRegister(ilId);
      setIlceler(Array.isArray(response.data?.data) ? response.data.data : []);
    } catch (error) {
      // console.error("❌ İlçeler yüklenirken hata:", error);
      setIlceler([]);
    }
  }, []);

  // fetchKullaniciData fonksiyonu
  const fetchKullaniciData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getUsers();

      // Frontend'de KULLANICI_CESIT_ID = 11 olanları filtrele
      const allUsers = response.data.data || [];
      const filteredUsers = allUsers.filter(
        (user) => user.KULLANICI_CESIT_ID === 11
      );

      //console.log("📋 Tüm kullanıcılar:", allUsers.length);
      //console.log(
      //  "🎯 Filtrelenmiş kullanıcılar (CESIT_ID = 11):",
      //  filteredUsers.length
      //);
      setKullaniciData(filteredUsers);
    } catch (err) {
      enqueueSnackbar("Kullanıcılar alınamadı.", { variant: "error" });
      // console.error("Kullanıcı verisi hatası:", err);
    } finally {
      setLoading(false);
    }
  }, [enqueueSnackbar]);

  // ARTIK useEffect'LER GÜVENLİ BİR ŞEKİLDE FONKSİYONLARI KULLANABİLİR

  useEffect(() => {
    fetchTanimVerileri();
  }, [fetchTanimVerileri]);

  useEffect(() => {
    const loadInitialData = async () => {
      if (activeTab === 0) {
        setLoading(true);
        try {
          const [ureticiRes, illerRes] = await Promise.all([
            getUreticiBilgileri(),
            getIllerForRegister(),
          ]);

          const producerData = ureticiRes.data.data[0] || {};
          setUreticiData(producerData);
          setIller(illerRes.data.data || []);

          if (producerData.IL_ID) {
            const ilcelerRes = await getIlcelerForRegister(producerData.IL_ID);
            setIlceler(ilcelerRes.data.data || []);
          }
        } catch (err) {
          enqueueSnackbar("Veriler yüklenirken bir hata oluştu.", {
            variant: "error",
          });
          // console.error(err);
        } finally {
          setLoading(false);
        }
      } else if (activeTab === 1) {
        fetchKullaniciData();
      }
    };

    loadInitialData();
  }, [activeTab, fetchKullaniciData]); // ← Artık güvenli

  useEffect(() => {
    if (ureticiData.IL_ID) {
      fetchIlceler(ureticiData.IL_ID);
    }
  }, [ureticiData.IL_ID, fetchIlceler]);

  // DİĞER FONKSIYONLAR (handleUreticiChange, handleIlChange, vs.)
  const handleUreticiChange = (e) =>
    setUreticiData({ ...ureticiData, [e.target.name]: e.target.value });

  const handleIlChange = (e) => {
    const newIlId = e.target.value;
    setUreticiData({ ...ureticiData, IL_ID: newIlId, ILCE_ID: "" });
    fetchIlceler(newIlId);
  };

  const handleSaveUretici = async () => {
    setLoading(true);
    const payload = {
      URETICI_ADI: ureticiData.URETICI_ADI || "",
      URETICI_SIRKET_ADI: ureticiData.URETICI_SIRKET_ADI || "",
      URETICI_VERGI_DAIRESI: ureticiData.URETICI_VERGI_DAIRESI || "",
      URETICI_VERGI_NO: ureticiData.URETICI_VERGI_NO || "",
      ENTEGRE_SIRKET_ID: ureticiData.ENTEGRE_SIRKET_ID || null,
      IL_ID: ureticiData.IL_ID || null,
      ILCE_ID: ureticiData.ILCE_ID || null,
      ADRES: ureticiData.ADRES || "",
      SORUMLU_ADI1: ureticiData.SORUMLU_ADI1 || "",
      TEL1: ureticiData.TEL1 || "",
    };

    try {
      await saveProducer(payload);
      enqueueSnackbar("Üretici bilgileri başarıyla kaydedildi.", {
        variant: "success",
      });
      sessionStorage.setItem(
  "URETICI_CACHE",
  JSON.stringify({
    URETICI_ADI: payload.URETICI_ADI,
    URETICI_SIRKET_ADI: payload.URETICI_SIRKET_ADI,
  })
);
    } catch (err) {
      enqueueSnackbar(`Kaydetme başarısız: ${err.message}`, {
        variant: "error",
      });
      // console.error("Kaydetme hatası:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenUserModal = (user = null) => {
    setEditingUser(user);
    setIsUserModalOpen(true);
  };

  const handleCloseUserModal = () => setIsUserModalOpen(false);

  // UreticiBilgileri.js ana component'inde bu fonksiyonu ekleyin:
  const handleUserIlChange = useCallback(
    async (ilId) => {
      try {
        if (!ilId) {
          setIlceler([]);
          return;
        }

        //console.log("Kullanıcı İlçeleri yükleniyor, İl ID:", ilId);
        const response = await getIlcelerForRegister(ilId); // ← Bakıcı modal'daki aynı API

        //console.log("İlçeler response:", response.data);
        const ilceData = response.data?.data || response.data || [];
        setIlceler(Array.isArray(ilceData) ? ilceData : []);
      } catch (error) {
        // console.error("İlçeler yüklenirken hata:", error);
        setIlceler([]);
        enqueueSnackbar("İlçeler yüklenirken hata oluştu", {
          variant: "error",
        });
      }
    },
    [enqueueSnackbar]
  );

  return (
     <Box className="uretici-page-shell">
    <Paper className="uretici-bilgileri-paper">
      <Box className="tabs-container">
        <Tabs
          value={activeTab}
          onChange={(e, val) => setActiveTab(val)}
          className="custom-tabs"
        >
          <Tab label="Üretici Bilgileri" className="custom-tab" />
          <Tab label="Kullanıcı Bilgileri" className="custom-tab" />
        </Tabs>
      </Box>

{activeTab === 0 && (
  <Box
    component="form"
    noValidate
    autoComplete="off"
    className="form-container"
  >
    {loading ? (
      <div className="loading-container">
        <CircularProgress className="loading-spinner" />
      </div>
    ) : (
      <Stack spacing={3} className="form-stack">
        {/* Genel Bilgiler */}
        <Box className="section-header-box">
          <Box className="section-icon_Uretici">
            <FaBuilding size={20} />
          </Box>
          <Typography variant="h6" component="h2" className="section-title">
            Genel Bilgiler
          </Typography>
        </Box>

        <Box className="form-grid-2">
          <TextField
            name="URETICI_ADI"
            label="Üretici Adı"
            margin="normal"
            value={ureticiData.URETICI_ADI || ""}
            onChange={handleUreticiChange}
            variant="outlined"
            className="custom-textfield"
            fullWidth
          />

          <TextField
            name="URETICI_SIRKET_ADI"
            label="Üretici Şirket Adı"
            margin="normal"
            value={ureticiData.URETICI_SIRKET_ADI || ""}
            onChange={handleUreticiChange}
            variant="outlined"
            className="custom-textfield"
            fullWidth
          />
        </Box>

        <Box className="form-grid-2">
          <TextField
            name="URETICI_VERGI_DAIRESI"
            label="Vergi Dairesi"
            margin="normal"
            value={ureticiData.URETICI_VERGI_DAIRESI || ""}
            onChange={handleUreticiChange}
            variant="outlined"
            className="custom-textfield"
            fullWidth
          />

          <TextField
            name="URETICI_VERGI_NO"
            label="Vergi No"
            margin="normal"
            value={ureticiData.URETICI_VERGI_NO || ""}
            onChange={handleUreticiChange}
            variant="outlined"
            className="custom-textfield"
            fullWidth
            maxWidth="300px"
          />
        </Box>

        <Box className="form-grid-1">
          <FormControl fullWidth className="custom-select-wrapper">
            <InputLabel>Entegre Şirket</InputLabel>
            <Select
              name="ENTEGRE_SIRKET_ID"
              value={ureticiData.ENTEGRE_SIRKET_ID || ""}
              label="Entegre Şirket"
              onChange={handleUreticiChange}
            >
              {sirketler.map((sirket) => (
                <MenuItem
                  key={sirket.ENTEGRE_SIRKET_ID}
                  value={sirket.ENTEGRE_SIRKET_ID}
                >
                  {sirket.SIRKET_ADI}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {/* Adres Bilgileri */}
        <Box className="section-header-box">
          <Box className="section-icon_Uretici">
            <FaMapMarkedAlt size={20} />
          </Box>
          <Typography variant="h6" component="h2" className="section-title">
            Adres Bilgileri
          </Typography>
        </Box>

        <Box className="form-grid-2">
          <FormControl fullWidth className="custom-select-wrapper">
            <InputLabel>İl</InputLabel>
            <Select
              name="IL_ID"
              value={ureticiData.IL_ID || ""}
              label="İl"
              margin="normal"
              onChange={handleIlChange}
            >
              {iller.map((il) => (
                <MenuItem key={il.IL_ID} value={il.IL_ID}>
                  {il.IL_ADI}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth className="custom-select-wrapper">
            <InputLabel>İlçe</InputLabel>
            <Select
              name="ILCE_ID"
              value={ureticiData.ILCE_ID || ""}
              label="İlçe"
              margin="normal"
              onChange={handleUreticiChange}
              disabled={!ureticiData.IL_ID || ilceler.length === 0}
            >
              {ilceler.map((ilce) => (
                <MenuItem key={ilce.ILCE_ID} value={ilce.ILCE_ID}>
                  {ilce.ILCE_ADI}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <Box className="form-grid-1">
          <TextField
            name="ADRES"
            label="Adres"
            margin="normal"
            multiline
            rows={3}
            value={ureticiData.ADRES || ""}
            onChange={handleUreticiChange}
            variant="outlined"
            className="custom-textfield"
            fullWidth
          />
        </Box>

        {/* Sorumlu Bilgileri */}
        <Box className="section-header-box">
          <Box className="section-icon_Uretici">
            <FaUserTie size={20} />
          </Box>
          <Typography variant="h6" component="h2" className="section-title">
            Sorumlu Bilgileri
          </Typography>
        </Box>

        <Box className="form-grid-2">
          <TextField
            name="SORUMLU_ADI1"
            label="Sorumlu Adı"
            margin="normal"
            value={ureticiData.SORUMLU_ADI1 || ""}
            onChange={handleUreticiChange}
            variant="outlined"
            className="custom-textfield"
            fullWidth
          />

          <TextField
            name="TEL1"
            label="Sorumlu No"
            margin="normal"
            value={ureticiData.TEL1 || ""}
            onChange={handleUreticiChange}
            variant="outlined"
            className="custom-textfield"
            fullWidth
          />
        </Box>

        <Button
          variant="contained"
          startIcon={<FaSave />}
          onClick={handleSaveUretici}
          className="save-button"
        >
          Kaydet
        </Button>
      </Stack>
    )}
  </Box>
)}

      {activeTab === 1 && (
        <Box className="users-container">
          {/* Header */}
          <Box className="users-header">
            <Typography variant="h4" className="users-title">
              <Box className="users-title-icon">
                <FaUserTie size={20} />
              </Box>
              Kullanıcı Yönetimi
            </Typography>
            <Box className="users-stats">
              <Box className="stat-item">
                <FaUsers size={14} />
                {kullaniciData.length} Kullanıcı
              </Box>
              <Button
                variant="contained"
                startIcon={<FaPlus />}
                onClick={() => handleOpenUserModal(null)}
                className="add-user-button"
              >
                Yeni Kullanıcı
              </Button>
            </Box>
          </Box>

          {/* Table */}
          <TableContainer component={Paper} className="users-table-container">
            <Table size="small" className="users-table">
              <TableHead>
                <TableRow className="table-header-row">
                  <TableCell>Kullanıcı</TableCell>
                  <TableCell>İletişim</TableCell>
                  <TableCell>Konum</TableCell>
                  {/* ✅ İşlemler kolonu kaldırıldı */}
                </TableRow>
              </TableHead>
              <TableBody>
                {kullaniciData.map((user) => (
                  <TableRow key={user.KULLANICI_ID}>
                    <TableCell>
                      <Box className="user-info">
                        <Box className="user-avatar">
                          {user.KULLANICI_ADI?.charAt(0)}
                          {user.KULLANICI_SOYADI?.charAt(0)}
                        </Box>
                        <Box className="user-details">
                          <Typography className="user-name">
                            {user.KULLANICI_ADI} {user.KULLANICI_SOYADI}
                          </Typography>
                          <Typography className="user-role">
                            Kullanıcı
                          </Typography>
                        </Box>
                      </Box>
                    </TableCell>

                    {/* ✅ İLETİŞİM KOLONU - TELEFON GÖSTERSİN */}
                    <TableCell>
                      <Box className="contact-info">
                        <Box className="contact-item">
                          <FaPhone className="contact-icon" />
                          <Typography variant="body2" component="span">
                            {user.KULLANICI_TEL_NO || "Telefon belirtilmemiş"}
                          </Typography>
                        </Box>
                      </Box>
                    </TableCell>

                    {/* ✅ KONUM KOLONU - İL/İLÇE FORMATI */}
                    <TableCell>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 500, color: "#374151" }}
                      >
                        {(() => {
                          const il = user.DOGUM_IL_ADI || "";
                          const ilce = user.DOGUM_ILCE_ADI || "";

                          if (il && ilce) {
                            return `${il}/${ilce}`;
                          } else if (il) {
                            return il;
                          } else {
                            return "—";
                          }
                        })()}
                      </Typography>
                    </TableCell>

                    {/* ❌ İŞLEMLER KOLONU TAMAMEN KALDIRILDI */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}

      <KullaniciModal
        open={isUserModalOpen}
        handleClose={handleCloseUserModal}
        user={editingUser}
        refreshList={fetchKullaniciData}
        iller={iller}
        ilceler={ilceler}
        ulkeler={ulkeler}
        egitimDurumlari={egitimDurumlari}
        onIlChange={handleUserIlChange}
      />
    </Paper>
    </Box>
  );
};

const KullaniciModal = ({
  open,
  handleClose,
  user,
  refreshList,
  iller = [],
  ilceler = [],
  ulkeler = [],
  egitimDurumlari = [],
  onIlChange,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  // Form state'i - Backend'e gönderilecek alan adları ile
  const [formData, setFormData] = useState({
    KULLANICI_ADI: "",
    KULLANICI_SOYADI: "",
    KULLANICI_EMAIL: "",
    KULLANICI_TEL_NO: "",
    KULLANICI_PASSWORD: "",
    TCKN: "",
    UYRUK_ULKE_ID: "",
    DOGUM_TARIHI: "",
    DOGUM_IL_ID: "",
    DOGUM_ILCE_ID: "",
    EGITIM_DURUMU_ID: "",
    CINSIYET: "",
    EVLIMI: "",
    COCUK_SAYISI: "",
  });

  // Hata state'i
  const [errors, setErrors] = useState({
    KULLANICI_ADI: false,
    KULLANICI_SOYADI: false,
    KULLANICI_EMAIL: false,
    KULLANICI_TEL_NO: false,
    KULLANICI_PASSWORD: false,
    TCKN: false,
    CINSIYET: false,
    EVLIMI: false,
  });

  // Telefon formatı fonksiyonları - DÜZELTİLMİŞ
  const formatPhoneNumber = (value) => {
    if (!value) return "";

    let cleaned = value.replace(/\D/g, "");

    // 0 ile başlamıyorsa ekle
    if (cleaned.length > 0 && cleaned[0] !== "0") {
      cleaned = "0" + cleaned;
    }

    // Maksimum 11 hane
    cleaned = cleaned.substring(0, 11);

    // Format: (0XXX) XXX XXXX
    const match = cleaned.match(/^(\d{0,4})(\d{0,3})(\d{0,4})$/);
    if (match) {
      let formatted = "";
      if (match[1]) {
        formatted += `(${match[1]})`;
      }
      if (match[2]) {
        formatted += ` ${match[2]}`;
      }
      if (match[3]) {
        formatted += ` ${match[3]}`;
      }
      return formatted.trim();
    }

    return cleaned;
  };

  const unformatPhoneNumber = (value) => {
    if (!value) return "";

    const cleaned = value.replace(/\D/g, "");

    // 0 ile başlamıyorsa ekle
    if (cleaned.length > 0 && cleaned[0] !== "0") {
      return "0" + cleaned.substring(0, 10);
    }

    return cleaned;
  };

  // Ad ve Soyad formatı fonksiyonları
  const formatAd = (value) => {
    return value
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const formatSoyad = (value) => {
    return value.toUpperCase();
  };

  // Modal açıldığında form verilerini doldur
  useEffect(() => {
    if (open) {
      if (user) {
        // Düzenleme modu - mevcut kullanıcı verilerini doldur
        // console.log("🔄 Mevcut kullanıcı verileri yükleniyor:", user);

        // Tarih formatını dönüştür
        let formattedDate = "";
        if (user.DOGUM_TARIHI) {
          if (typeof user.DOGUM_TARIHI === "object" && user.DOGUM_TARIHI.year) {
            const day = String(user.DOGUM_TARIHI.day).padStart(2, "0");
            const month = String(user.DOGUM_TARIHI.month).padStart(2, "0");
            const year = user.DOGUM_TARIHI.year;
            formattedDate = `${year}-${month}-${day}`;
          } else if (String(user.DOGUM_TARIHI).includes(".")) {
            const [day, month, year] = user.DOGUM_TARIHI.split(".");
            formattedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(
              2,
              "0"
            )}`;
          } else if (String(user.DOGUM_TARIHI).includes("T")) {
            formattedDate = user.DOGUM_TARIHI.split("T")[0];
          } else {
            formattedDate = String(user.DOGUM_TARIHI);
          }
        }

        setFormData({
          KULLANICI_ADI: user.KULLANICI_ADI || "",
          KULLANICI_SOYADI: user.KULLANICI_SOYADI || "",
          KULLANICI_EMAIL: user.KULLANICI_EMAIL || "",
          KULLANICI_TEL_NO: user.KULLANICI_TEL_NO || "",
          KULLANICI_PASSWORD: "",
          TCKN: user.TCKN || "",
          UYRUK_ULKE_ID: user.UYRUK_ULKE_ID || "",
          DOGUM_TARIHI: formattedDate,
          DOGUM_IL_ID: user.DOGUM_IL_ID || "",
          DOGUM_ILCE_ID: user.DOGUM_ILCE_ID || "",
          EGITIM_DURUMU_ID: user.EGITIM_DURUMU_ID || "",
          CINSIYET: user.CINSIYET || "",
          EVLIMI: user.EVLIMI || "",
          COCUK_SAYISI: user.COCUK_SAYISI || "",
        });

        if (user.DOGUM_IL_ID && onIlChange) {
          onIlChange(user.DOGUM_IL_ID);
        }
      } else {
        // Yeni ekleme modu - formu temizle
        //console.log("🆕 Yeni kullanıcı formu temizleniyor");
        setFormData({
          KULLANICI_ADI: "",
          KULLANICI_SOYADI: "",
          KULLANICI_EMAIL: "",
          KULLANICI_TEL_NO: "",
          KULLANICI_PASSWORD: "",
          TCKN: "",
          UYRUK_ULKE_ID: "",
          DOGUM_TARIHI: "",
          DOGUM_IL_ID: "",
          DOGUM_ILCE_ID: "",
          EGITIM_DURUMU_ID: "",
          CINSIYET: "",
          EVLIMI: "",
          COCUK_SAYISI: "",
        });
      }

      // Hataları temizle
      setErrors({
        KULLANICI_ADI: false,
        KULLANICI_SOYADI: false,
        KULLANICI_EMAIL: false,
        KULLANICI_TEL_NO: false,
        KULLANICI_PASSWORD: false,
        TCKN: false,
        CINSIYET: false,
        EVLIMI: false,
      });
    }
  }, [user, open, onIlChange]);

  // Input change handler
  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    // Kullanıcı yazmaya başladığında hatayı temizle
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: false }));
    }
  };

  // İl değişikliği handler
  const handleIlChange = (e) => {
    const ilId = e.target.value;
    setFormData((prev) => ({
      ...prev,
      DOGUM_IL_ID: ilId,
      DOGUM_ILCE_ID: "", // İl değiştiğinde ilçeyi sıfırla
    }));

    if (onIlChange && ilId) {
      onIlChange(ilId);
    }
  };

  // Form gönder
  const handleSubmit = async () => {
    //console.log("=== KULLANICI FORM GÖNDER DEBUG ===");
    //console.log("Form Data:", formData);

    // ✅ TELEFON DEBUG LOGLARINI EKLE
    //console.log("📱 Telefon Debug:");
    // console.log("  - Ham telefon:", formData.KULLANICI_TEL_NO);
    //console.log("  - Telefon uzunluğu:", formData.KULLANICI_TEL_NO?.length);
    //console.log("  - Telefon tipi:", typeof formData.KULLANICI_TEL_NO);
    //console.log(
    //  "  - Formatlanmış hali:",
    //  formatPhoneNumber(formData.KULLANICI_TEL_NO)
    // );

    // Hata state'ini sıfırla
    const newErrors = {
      KULLANICI_ADI: false,
      KULLANICI_SOYADI: false,
      KULLANICI_EMAIL: false,
      KULLANICI_TEL_NO: false,
      KULLANICI_PASSWORD: false,
      TCKN: false,
      CINSIYET: false,
      EVLIMI: false,
    };

    // Validasyon ve hataları işaretle
    let hasError = false;

    if (!formData.KULLANICI_ADI?.trim()) {
      newErrors.KULLANICI_ADI = true;
      hasError = true;
    }

    if (!formData.KULLANICI_SOYADI?.trim()) {
      newErrors.KULLANICI_SOYADI = true;
      hasError = true;
    }

    if (!formData.KULLANICI_EMAIL?.trim()) {
      newErrors.KULLANICI_EMAIL = true;
      hasError = true;
    }

    if (!formData.KULLANICI_TEL_NO?.trim()) {
      newErrors.KULLANICI_TEL_NO = true;
      hasError = true;
    }

    if (!user && !formData.KULLANICI_PASSWORD?.trim()) {
      newErrors.KULLANICI_PASSWORD = true;
      hasError = true;
    }

    if (!formData.TCKN?.trim()) {
      newErrors.TCKN = true;
      hasError = true;
    }

    if (!formData.CINSIYET) {
      newErrors.CINSIYET = true;
      hasError = true;
    }

    if (!formData.EVLIMI) {
      newErrors.EVLIMI = true;
      hasError = true;
    }

    setErrors(newErrors);

    if (hasError) {
      enqueueSnackbar("Lütfen zorunlu alanları doldurun", {
        variant: "warning",
      });
      return;
    }

    // Email formatı kontrolü
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.KULLANICI_EMAIL)) {
      enqueueSnackbar("Geçerli bir email adresi girin", {
        variant: "warning",
      });
      return;
    }

    // ✅ DÜZELTİLMİŞ TELEFON KONTROLÜ
    const cleanPhone = formData.KULLANICI_TEL_NO.replace(/\D/g, ""); // Sadece rakamları al
    //console.log(
    //  "📱 Temizlenmiş telefon:",
    //  cleanPhone,
    //  "Uzunluk:",
    //  cleanPhone.length
    //);

    if (cleanPhone && cleanPhone.length !== 11) {
      enqueueSnackbar(
        `Telefon numarası 11 haneli olmalıdır (Girilen: ${cleanPhone.length} hane)`,
        {
          variant: "warning",
        }
      );
      //console.log("❌ Telefon uzunluk hatası:", {
      //girilen: cleanPhone,
      // uzunluk: cleanPhone.length,
      //  beklenen: 11,
      //  });
      return;
    }

    // ✅ DÜZELTİLMİŞ TCKN KONTROLÜ
    const cleanTCKN = formData.TCKN.replace(/\D/g, "");
    if (cleanTCKN && cleanTCKN.length !== 11) {
      enqueueSnackbar(
        `TC Kimlik Numarası 11 haneli olmalıdır (Girilen: ${cleanTCKN.length} hane)`,
        {
          variant: "warning",
        }
      );
      return;
    }

    setLoading(true);
    try {
      // Tarih formatını dönüştür: YYYY-MM-DD -> DD-MM-YYYY
      let formattedDate = "";
      if (formData.DOGUM_TARIHI) {
        const [year, month, day] = formData.DOGUM_TARIHI.split("-");
        formattedDate = `${day}-${month}-${year}`;
      }

      // API'ye gönderilecek data - TEMİZLENMİŞ TELEFON İLE
      const apiData = {
        KULLANICI_TEL_NO: cleanPhone, // ✅ Temizlenmiş telefon kullan
        KULLANICI_PASSWORD: formData.KULLANICI_PASSWORD,
        KULLANICI_ADI: formData.KULLANICI_ADI.trim(),
        KULLANICI_SOYADI: formData.KULLANICI_SOYADI.trim(),
        KULLANICI_EMAIL: formData.KULLANICI_EMAIL.trim(),
        TCKN: cleanTCKN, // ✅ Temizlenmiş TCKN kullan
        UYRUK_ULKE_ID: formData.UYRUK_ULKE_ID
          ? parseInt(formData.UYRUK_ULKE_ID)
          : null,
        DOGUM_TARIHI: formattedDate,
        DOGUM_IL_ID: formData.DOGUM_IL_ID
          ? parseInt(formData.DOGUM_IL_ID)
          : null,
        DOGUM_ILCE_ID: formData.DOGUM_ILCE_ID
          ? parseInt(formData.DOGUM_ILCE_ID)
          : null,
        EGITIM_DURUMU_ID: formData.EGITIM_DURUMU_ID
          ? parseInt(formData.EGITIM_DURUMU_ID)
          : null,
        CINSIYET: formData.CINSIYET,
        EVLIMI: formData.EVLIMI,
        COCUK_SAYISI: formData.COCUK_SAYISI
          ? parseInt(formData.COCUK_SAYISI)
          : null,
      };

      //console.log("📡 API'ye gönderilen data:", apiData);

      if (user) {
        // Güncelleme modu
        const updateData = { ...apiData, KULLANICI_ID: user.KULLANICI_ID };
        await updateUser(updateData);
        enqueueSnackbar("Kullanıcı başarıyla güncellendi", {
          variant: "success",
        });
      } else {
        // Yeni ekleme modu
        await addUser(apiData);
        enqueueSnackbar("Kullanıcı başarıyla eklendi", {
          variant: "success",
        });
      }

      refreshList();
      handleClose();
    } catch (error) {
      // console.error("❌ Kullanıcı kayıt hatası:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "İşlem başarısız";
      enqueueSnackbar(`Hata: ${errorMessage}`, { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          minHeight: "70vh",
        },
      }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          backgroundColor: "#FF7A2B",
          color: "white",
          textAlign: "center",
          fontSize: "1.5rem",
          fontWeight: "bold",
          py: 2,
        }}
      >
        {user ? "Kullanıcı Bilgilerini Düzenle" : "Yeni Kullanıcı Ekle"}
      </DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        <Box sx={{ p: 3 }}>
          {/* Temel Bilgiler Bölümü - ULTRA KOMPAKT */}
          <Paper elevation={1} sx={{ p: 2, mb: 3, backgroundColor: "#f9f9f9" }}>
            <Typography
              variant="h6"
              sx={{
                mb: 1.5,
                color: "#FF7A2B",
                fontWeight: "bold",
                borderBottom: "2px solid #FF7A2B",
                pb: 0.5,
                fontSize: "1.1rem",
              }}
            >
              📋 Temel Bilgiler
            </Typography>

            {/* ✅ KOMPAKT GRID - 5 ALAN TEK SATIRDA */}
            <Grid container spacing={1.5}>
              <Grid item xs={6} sm={4} md={2.4}>
                <TextField
                  label="Ad *"
                  fullWidth
                  required
                  error={errors.KULLANICI_ADI}
                  value={formData.KULLANICI_ADI}
                  onChange={(e) => {
                    const formatted = formatAd(e.target.value);
                    handleInputChange("KULLANICI_ADI", formatted);
                  }}
                  variant="outlined"
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  FormHelperTextProps={{ sx: { fontSize: "0.7rem" } }}
                  helperText={errors.KULLANICI_ADI ? "Zorunlu" : ""}
                />
              </Grid>
              <Grid item xs={6} sm={4} md={2.4}>
                <TextField
                  label="Soyad *"
                  fullWidth
                  required
                  error={errors.KULLANICI_SOYADI}
                  value={formData.KULLANICI_SOYADI}
                  onChange={(e) => {
                    const formatted = formatSoyad(e.target.value);
                    handleInputChange("KULLANICI_SOYADI", formatted);
                  }}
                  variant="outlined"
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  FormHelperTextProps={{ sx: { fontSize: "0.7rem" } }}
                  helperText={errors.KULLANICI_SOYADI ? "Zorunlu" : ""}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={2.4}>
                <TextField
                  label="E-posta *"
                  type="email"
                  fullWidth
                  required
                  error={errors.KULLANICI_EMAIL}
                  value={formData.KULLANICI_EMAIL}
                  onChange={(e) =>
                    handleInputChange("KULLANICI_EMAIL", e.target.value)
                  }
                  variant="outlined"
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  FormHelperTextProps={{ sx: { fontSize: "0.7rem" } }}
                  helperText={errors.KULLANICI_EMAIL ? "Zorunlu" : ""}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={2.4}>
                <TextField
                  label="Telefon *"
                  fullWidth
                  required
                  error={errors.KULLANICI_TEL_NO}
                  value={formatPhoneNumber(formData.KULLANICI_TEL_NO)}
                  onChange={(e) => {
                    const unformatted = unformatPhoneNumber(e.target.value);
                    // console.log("📱 Telefon değişti:", {
                    //   input: e.target.value,
                    //   unformatted: unformatted,
                    //   length: unformatted.length,
                    // });
                    handleInputChange("KULLANICI_TEL_NO", unformatted);
                  }}
                  placeholder="(0XXX) XXX XXXX"
                  inputProps={{ maxLength: 17 }}
                  variant="outlined"
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  FormHelperTextProps={{ sx: { fontSize: "0.7rem" } }}
                  helperText={
                    errors.KULLANICI_TEL_NO
                      ? "Zorunlu"
                      : `11 haneli (${
                          formData.KULLANICI_TEL_NO?.replace(/\D/g, "")
                            ?.length || 0
                        }/11)`
                  }
                />
              </Grid>
              <Grid item xs={6} sm={6} md={2.4}>
                <TextField
                  label={user ? "Yeni Şifre" : "Şifre *"}
                  type="password"
                  fullWidth
                  required={!user}
                  error={errors.KULLANICI_PASSWORD}
                  value={formData.KULLANICI_PASSWORD}
                  onChange={(e) =>
                    handleInputChange("KULLANICI_PASSWORD", e.target.value)
                  }
                  variant="outlined"
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  FormHelperTextProps={{ sx: { fontSize: "0.7rem" } }}
                  helperText={
                    errors.KULLANICI_PASSWORD
                      ? "Zorunlu"
                      : user
                      ? "Opsiyonel"
                      : "Minimum 6 haneli olmalıdır."
                  }
                />
              </Grid>
            </Grid>
          </Paper>

          {/* Kişisel Bilgiler Bölümü */}
          <Paper elevation={1} sx={{ p: 3, mb: 3, backgroundColor: "#f9f9f9" }}>
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                color: "#FF7A2B",
                fontWeight: "bold",
                borderBottom: "2px solid #FF7A2B",
                pb: 1,
              }}
            >
              👤 Kişisel Bilgiler
            </Typography>

            {/* ✅ DÜZELTİLMİŞ GRID - UYRUK ALANI DA AYNI BOYUTTA */}
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <TextField
                  label="TC Kimlik Numarası *"
                  fullWidth
                  required
                  error={errors.TCKN}
                  helperText={errors.TCKN ? "TCKN alanı zorunludur" : ""}
                  value={formData.TCKN}
                  onChange={(e) => handleInputChange("TCKN", e.target.value)}
                  inputProps={{ maxLength: 11 }}
                  variant="outlined"
                  sx={{ backgroundColor: "white" }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl
                  fullWidth
                  sx={{
                    backgroundColor: "white",
                    minWidth: 260,
                  }}
                >
                  <InputLabel>Uyruk</InputLabel>
                  <Select
                    value={formData.UYRUK_ULKE_ID}
                    label="Uyruk"
                    onChange={(e) =>
                      handleInputChange("UYRUK_ULKE_ID", e.target.value)
                    }
                  >
                    <MenuItem value="">Seçiniz</MenuItem>
                    {ulkeler.map((ulke) => (
                      <MenuItem key={ulke.ULKE_ID} value={ulke.ULKE_ID}>
                        {ulke.ULKEADI}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Doğum Tarihi"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={formData.DOGUM_TARIHI}
                  onChange={(e) =>
                    handleInputChange("DOGUM_TARIHI", e.target.value)
                  }
                  variant="outlined"
                  sx={{ backgroundColor: "white" }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Çocuk Sayısı"
                  type="number"
                  fullWidth
                  value={formData.COCUK_SAYISI}
                  onChange={(e) =>
                    handleInputChange("COCUK_SAYISI", e.target.value)
                  }
                  helperText="Çocuğu yoksa boş bırakabilirsiniz"
                  inputProps={{ min: 0, max: 20 }}
                  variant="outlined"
                  sx={{ backgroundColor: "white" }}
                />
              </Grid>
            </Grid>
          </Paper>
          {/* Doğum Yeri - Sadece Türkiye vatandaşları için */}
          {formData.UYRUK_ULKE_ID === 168 && (
            <Paper elevation={1} sx={{ p: 3, backgroundColor: "#f9f9f9" }}>
              <Typography
                variant="h6"
                sx={{
                  mb: 2,
                  color: "#FF7A2B",
                  fontWeight: "bold",
                  borderBottom: "2px solid #FF7A2B",
                  pb: 1,
                }}
              >
                📍 Doğum Yeri
              </Typography>

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth sx={{ backgroundColor: "white" }}>
                    <InputLabel>Doğum İli</InputLabel>
                    <Select
                      value={formData.DOGUM_IL_ID}
                      label="Doğum İli"
                      onChange={handleIlChange}
                    >
                      <MenuItem value="">Seçiniz</MenuItem>
                      {iller.map((il) => (
                        <MenuItem key={il.IL_ID} value={il.IL_ID}>
                          {il.IL_ADI}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl
                    fullWidth
                    disabled={!formData.DOGUM_IL_ID || ilceler.length === 0}
                    sx={{
                      backgroundColor: formData.DOGUM_IL_ID
                        ? "white"
                        : "#f5f5f5",
                    }}
                  >
                    <InputLabel>Doğum İlçesi</InputLabel>
                    <Select
                      value={formData.DOGUM_ILCE_ID}
                      label="Doğum İlçesi"
                      onChange={(e) =>
                        handleInputChange("DOGUM_ILCE_ID", e.target.value)
                      }
                    >
                      <MenuItem value="">Seçiniz</MenuItem>
                      {ilceler.map((ilce) => (
                        <MenuItem key={ilce.ILCE_ID} value={ilce.ILCE_ID}>
                          {ilce.ILCE_ADI}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Paper>
          )}

          {/* Cinsiyet ve Medeni Durum */}
          <Paper elevation={1} sx={{ p: 3, mb: 3, backgroundColor: "#f9f9f9" }}>
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                color: "#FF7A2B",
                fontWeight: "bold",
                borderBottom: "2px solid #FF7A2B",
                pb: 1,
              }}
            >
              👥 Demografik Bilgiler
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    backgroundColor: "white",
                    p: 2,
                    borderRadius: 1,
                    border: errors.CINSIYET
                      ? "2px solid #d32f2f"
                      : "1px solid #ddd",
                  }}
                >
                  <FormControl component="fieldset" error={errors.CINSIYET}>
                    <FormLabel
                      component="legend"
                      sx={{
                        color: errors.CINSIYET ? "#d32f2f" : "#FF7A2B",
                        fontWeight: "bold",
                        mb: 1,
                      }}
                    >
                      Cinsiyet *
                    </FormLabel>
                    <RadioGroup
                      row
                      value={formData.CINSIYET}
                      onChange={(e) =>
                        handleInputChange("CINSIYET", e.target.value)
                      }
                    >
                      <FormControlLabel
                        value="K"
                        control={<Radio sx={{ color: "#FF7A2B" }} />}
                        label="Kadın"
                      />
                      <FormControlLabel
                        value="E"
                        control={<Radio sx={{ color: "#FF7A2B" }} />}
                        label="Erkek"
                      />
                      <FormControlLabel
                        value="B"
                        control={<Radio sx={{ color: "#FF7A2B" }} />}
                        label="Belirtmek İstemiyorum"
                      />
                    </RadioGroup>
                    {errors.CINSIYET && (
                      <Typography variant="caption" color="error">
                        Cinsiyet alanı zorunludur
                      </Typography>
                    )}
                  </FormControl>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    backgroundColor: "white",
                    p: 2,
                    borderRadius: 1,
                    border: errors.EVLIMI
                      ? "2px solid #d32f2f"
                      : "1px solid #ddd",
                  }}
                >
                  <FormControl component="fieldset" error={errors.EVLIMI}>
                    <FormLabel
                      component="legend"
                      sx={{
                        color: errors.EVLIMI ? "#d32f2f" : "#FF7A2B",
                        fontWeight: "bold",
                        mb: 1,
                      }}
                    >
                      Medeni Durum *
                    </FormLabel>
                    <RadioGroup
                      row
                      value={formData.EVLIMI}
                      onChange={(e) =>
                        handleInputChange("EVLIMI", e.target.value)
                      }
                    >
                      <FormControlLabel
                        value="E"
                        control={<Radio sx={{ color: "#FF7A2B" }} />}
                        label="Evli"
                      />
                      <FormControlLabel
                        value="H"
                        control={<Radio sx={{ color: "#FF7A2B" }} />}
                        label="Bekar"
                      />
                    </RadioGroup>
                    {errors.EVLIMI && (
                      <Typography variant="caption" color="error">
                        Medeni durum alanı zorunludur
                      </Typography>
                    )}
                  </FormControl>
                </Box>
              </Grid>
            </Grid>
          </Paper>

          {/* Eğitim Bilgileri */}
          <Paper elevation={1} sx={{ p: 3, mb: 3, backgroundColor: "#f9f9f9" }}>
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                color: "#FF7A2B",
                fontWeight: "bold",
                borderBottom: "2px solid #FF7A2B",
                pb: 1,
              }}
            >
              🎓 Eğitim Bilgileri
            </Typography>

            <FormControl fullWidth sx={{ backgroundColor: "white" }}>
              <InputLabel>Eğitim Durumu</InputLabel>
              <Select
                value={formData.EGITIM_DURUMU_ID}
                label="Eğitim Durumu"
                onChange={(e) =>
                  handleInputChange("EGITIM_DURUMU_ID", e.target.value)
                }
              >
                <MenuItem value="">Seçiniz</MenuItem>
                {egitimDurumlari.map((egitim) => (
                  <MenuItem
                    key={egitim.EGITIM_DURUMU_ID}
                    value={egitim.EGITIM_DURUMU_ID}
                  >
                    {egitim.EGITIM_DURUMU_NAME}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Paper>
        </Box>
      </DialogContent>

      {/* Footer */}
      <DialogActions
        sx={{
          p: 3,
          backgroundColor: "#f5f5f5",
          justifyContent: "space-between",
        }}
      >
        <Button
          onClick={handleClose}
          disabled={loading}
          variant="outlined"
          size="large"
          sx={{
            borderColor: "#ccc",
            color: "#666",
            minWidth: 120,
          }}
        >
          İptal
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={loading}
          size="large"
          sx={{
            backgroundColor: "#FF7A2B",
            "&:hover": { backgroundColor: "#F57C00" },
            minWidth: 120,
            py: 1.5,
          }}
        >
          {loading ? (
            <>
              <CircularProgress size={20} sx={{ mr: 1, color: "white" }} />
              Kaydediliyor...
            </>
          ) : user ? (
            "Güncelle"
          ) : (
            "Kaydet"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UreticiBilgileri;
